import { render } from "./PracticeView.vue?vue&type=template&id=b03158e8"
import script from "./PracticeView.vue?vue&type=script&lang=js"
export * from "./PracticeView.vue?vue&type=script&lang=js"

import "./PracticeView.vue?vue&type=style&index=0&id=b03158e8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__